const uploadTypeImage = [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/gif",
    "image/webp",
];
const uploadTypeAudio = ["audio/mp3", "audio/mpeg", "audio/ogg"];
const uploadTypeVideo = ["video/mp4", "video/webm"];
const uploadTypeCSV = ["text/csv", "application/vnd.ms-excel"];
const uploadType3D = ["model/gltf+json", "model/gltf-binary"];
const uploadTypeMSTab = [
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
];
const uploadTypeMSDoc = [
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];
const uploadTypePdf = ["application/pdf"];

const getFileTypeMime = (type, name) => {
    if (uploadTypeImage.some((item) => item === type)) {
        return "image";
    }
    if (uploadTypeAudio.some((item) => item === type)) {
        return "audio";
    }
    if (uploadTypeVideo.some((item) => item === type)) {
        return "video";
    }
    if (uploadTypeCSV.some((item) => item === type) && /\.(csv)$/i.test(name)) {
        return "csv";
    }
    if (
        uploadType3D.some((item) => item === type) ||
        /\.(gltf|glb)$/i.test(name)
    ) {
        return "3d";
    }
    if (
        uploadTypeMSTab.some((item) => item === type) ||
        /\.(xls|xlsx)$/i.test(name)
    ) {
        return "table";
    }
    if (
        uploadTypeMSDoc.some((item) => item === type) ||
        /\.(doc|docx)$/i.test(name)
    ) {
        return "msword";
    }
    if (uploadTypePdf.some((item) => item === type) || /\.(pdf)$/i.test(name)) {
        return "pdf";
    }

    return "unknowtype";
};

export { getFileTypeMime };
